import React, { useCallback, useState } from 'react';
import Modal from '@mui/material/Modal';
import { Button, FormGroup, CircularProgress, Typography, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import styles from '../../SiteManagement/styles'; //TODO export these higher
import ssoManagementService from '../../../services/SSOManagementService';
import { ProviderSiteDTO, SSOProviderDTO, LTIPlatformDTO } from '@beable/roster-backend-client-v1';
import { SUBPAGES } from "../constants";

const getStyles = styles.deleteModalStyles;
interface DeleteModalProps {
    open: boolean;
    handleClose: any;
    subpage: string;
    item: ProviderSiteDTO | SSOProviderDTO | LTIPlatformDTO;
    name?: string;
}

export default function DeleteModal(props: DeleteModalProps) {
    const theme = useTheme();
    const styles = getStyles(theme);
    const [isLoading, setIsLoading] = useState(false);
    const [deletionSucceeded, setDeletionSucceeded] = useState(false);
    const [deletionActivated, setDeletionActivated] = useState(false);

    const submitForm = async () => {
        if (props.subpage === SUBPAGES.providers.value) {
            setIsLoading(true);
            setDeletionSucceeded(await ssoManagementService.deleteProvider(props.item.id!));
            setIsLoading(false);
        } else if(props.subpage === SUBPAGES.providerSites.value) {
            setIsLoading(true);
            setDeletionSucceeded(await ssoManagementService.deleteProviderSite(props.item.id!));
            setIsLoading(false);
        } else {
          setIsLoading(true);
          setDeletionSucceeded(await ssoManagementService.deleteLTIPlatform(props.item.id!));
          setIsLoading(false);
        }
        setDeletionActivated(true);
    };
    const resetState = () => {
        setIsLoading(false);
        setDeletionSucceeded(false);
        setDeletionActivated(false);
    };

    const handleClose = () => {
        const success = deletionSucceeded;
        resetState();
        props.handleClose(success);
    }

  const getTitle = useCallback(() => {
    return props.subpage === SUBPAGES.providers.value
      ? "SSO provider"
      : props.subpage === SUBPAGES.providerSites.value
        ? "SSO site"
        : "LTI platform";
  }, [props.subpage]);

    return (
        <Modal
            aria-labelledby="delete-modal-title"
            aria-describedby="delete-modal-description"
            open={props.open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    props.handleClose();
                }
            }}
        >
            <Box sx={{ ...styles.paper, ...styles.deleteModal }}>
                <h2 id="delete-modal-title">Are you sure you would like to delete the {props.name ? props.name : props.item.id} {getTitle()} record?</h2>
                <p id="delete-modal-description">This action cannot be undone.</p>
                <FormGroup sx={[styles.mt2, styles.dfr]}>
                    {isLoading ? <CircularProgress color="primary" /> : undefined}
                    {deletionSucceeded && deletionActivated ? <Typography sx={styles.greenTxt}>Deletion succeeded!</Typography> : undefined}
                    {!deletionSucceeded && deletionActivated ? <Typography sx={styles.redTxt}>Deletion failed!</Typography> : undefined}
                </FormGroup>
                <FormGroup sx={[styles.mt2, styles.dfr]}>
                    <Button variant="contained" disabled={deletionActivated && deletionSucceeded} sx={styles.btnDanger} onClick={submitForm}>Delete</Button>
                    <Button variant="contained" onClick={handleClose} sx={styles.closeBtn}>Close</Button>
                </FormGroup>
            </Box>
        </Modal>
    );
}